import { RouterStateParams } from '#shared/types/common';
import { createBrowserHistory } from 'history';

export const history = createBrowserHistory<RouterStateParams>({ getUserConfirmation() {} });
